import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string
  hint?: string
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ className, hint, id, label, ...rest }, ref) => (
    <label className={classNames(styles.wrapper, className)} htmlFor={id}>
      <span className={styles.box}>
        <input ref={ref} id={id} type="radio" className={styles.input} {...rest} />
        <span className={styles.dot} />
      </span>
      <span className={styles.text}>
        <strong>{label}</strong>
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </span>
    </label>
  ),
)

Radio.displayName = 'Radio'

export default Radio
